import http from './http'

export function getLoans(params = {}) {
  return http.get('loans', { params }).then((res) => res.data)
}

export function getLoansSummary(params = {}) {
  return http.get('loans/summary', { params }).then((res) => res.data)
}

export function createLoan(payload) {
  return http.post('loans', payload).then((res) => res.data)
}

export function markLoanPaid(id, amount) {
  return http.post(`loans/${id}/paid`, { amount }).then((res) => res.data)
}

export function cancelLoan(id, reason) {
  return http.post(`loans/${id}/cancel`, { reason }).then((res) => res.data)
}

export function getLoanHistory(id) {
  return http.get(`loans/${id}/history`).then((res) => res.data)
}
